import React from 'react'
import { Box, Heading, Text, Paragraph, Stack, Image } from 'grommet'
import styled from 'styled-components'
import { StaticQuery, graphql } from 'gatsby'
import RehypeReact from 'rehype-react'
import PWVideo from '../Adthrive/pwVideo'
import PWLogo from '../../images/Picker-Wheel-Logo-Small.png'
import TableOfContent from '../TableOfContent'
import Adthrive from '../Adthrive'
import { RelativeBox } from '../Common'
// import Ezoic from "../Ezoic/pEzoic"
// import { EzoicId } from "../Ezoic/ids"

const Headline = props => {
  let str = props.children
  let id = null
  if ((props.level === 2 || props.level === 3) && props.depth) {
    str = `${props.depth}. ${props.children}`
  }
  if (props.level === 2) {
    id = props.children[0]
    id = id.replace(/\s+/g, '-').toLowerCase()
  }
  return (
    <Heading
      level={props.level}
      id={id && id}
      // size={props.size}
      margin={{ top: props.marTop }}
    >
      {str}
    </Heading>
  )
}

const ParagraphLine = props => {
  return <Paragraph>{props.children}</Paragraph>
}

const Anchor = styled.a`
  cursor: pointer;
  text-decoration: none;
  color: ${props => props.theme.global.colors.secondary};
  font-weight: 700;
  @media (hover: hover) {
    &:hover {
      text-decoration: underline;
    }
  }
`

const BoxG = styled(Box)`
  font-size: 1.8rem;
`

const BoxC = props => {
  return <BoxG>{props.children}</BoxG>
}

const Separator = styled.hr`
  background-color: transparent;
  border-top: ${props => (props.type === 1 ? '3px solid' : '2px dashed')}
    ${props => props.theme.global.colors.border};
  width: 100%;
  margin-bottom: 0;
`

// const RelativeBox = styled(Box)`
//   position: relative;
//   margin-top: 2rem;
// `

const ImageLogo = styled(Image)`
  width: 2.5rem;
  height: 2.5rem;
  position: absolute;
  top: calc(50% - 1px);
  left: 50%;
  transform: translate(-50%, -50%);
`
const ParagraphSeparator = ({ type }) => {
  return (
    <RelativeBox margin={{ top: '2rem' }}>
      <Separator type={type} />
      <ImageLogo src={PWLogo} alt="Picker Wheel Logo" />
    </RelativeBox>
  )
}

// const Container = styled(Box)`
//   & .img {
//     border: 3px solid ${props => props.theme.global.colors.primary};
//   }
// `

const PickerWheelManual = ({ file }) => {
  const tableOfContent = []
  let h2Depth = 0
  let h3Depth = 0
  const renderAst = new RehypeReact({
    createElement: React.createElement,
    components: {
      h1: props => <Headline {...props} level={1} />,
      h2: props => {
        h3Depth = 0
        return <Headline {...props} depth={++h2Depth} level={2} marTop="4rem" />
      },
      h3: props => (
        <Headline
          {...props}
          depth={`${h2Depth}.${++h3Depth}`}
          level={3}
          marTop="2rem"
        />
      ),
      h4: props => <Headline {...props} level={4} marTop="1rem" />,
      separator1: props => <ParagraphSeparator type={1} />,
      separator2: props => <ParagraphSeparator type={2} />,
      p: ParagraphLine,
      div: BoxC,
      a: Anchor,
      pwvideo: props => <PWVideo marBot="-2rem" />,
      toc: props => {
        return (
          <TableOfContent menu={tableOfContent} title="Table of Contents" />
        )
      },
      specialheading: props => <Headline {...props} level={2} marTop="4rem" />,
      lastupdated: props => (
        <Text margin={{ bottom: '1rem' }}>
          <i>Version Updated: {props.children}</i>
        </Text>
      ),
      // ezoicfirstcontent: props => (
      //   <Ezoic alignSelf="stretch" align="center" id={EzoicId.inContent1} />
      // ),
      // ezoicsecondcontent: props => (
      //   <Ezoic alignSelf="stretch" align="center" id={EzoicId.inContent2} />
      // ),
      // ezoictoollinks: props => (
      //   <Ezoic alignSelf="stretch" align="center" id={EzoicId.aboveBlogTitle} />
      // ),
      affiliate: props => (
        <Text size="1.4rem">
          <i>
            This site contains affiliate links to products. We may receive a
            commission for purchases made through these links.
          </i>
        </Text>
      ),
    },
  }).Compiler

  return (
    <StaticQuery
      query={query}
      render={data => {
        const allContent = data[file].childMarkdownRemark.htmlAst.children
        const menuContent = allContent.filter(
          tempNode => tempNode.tagName === 'h2',
        )
        for (const item of menuContent) {
          if (!tableOfContent.includes(item.children[0].value)) {
            tableOfContent.push(item.children[0].value)
          }
        }
        h2Depth = 0
        h3Depth = 0

        return (
          <Adthrive id="pageMD">
            {renderAst(data[file].childMarkdownRemark.htmlAst)}
          </Adthrive>
          // <>
          //   {typeof window === 'undefined' ||
          //   process.env.GATSBY_BUILD_CONTEXT === 'development' ||
          //   isPremium || premiumHistory ? (
          //     <div id="pageMD">
          //       {renderAst(data[file].childMarkdownRemark.htmlAst)}
          //     </div>
          //   ) : (
          //     <div
          //       id="pageMD"
          //       dangerouslySetInnerHTML={{
          //         __html: '',
          //       }}
          //       //   suppressHydrationWarning
          //     />
          //   )}
          // </>
        )
      }}
    />
  )
}

export default PickerWheelManual

const query = graphql`
  query {
    PickerWheelManual: file(relativePath: { eq: "PickerWheelManual.md" }) {
      childMarkdownRemark {
        htmlAst
      }
    }
    RTGManual: file(relativePath: { eq: "RTGManual.md" }) {
      childMarkdownRemark {
        htmlAst
      }
    }
    YNWManual: file(relativePath: { eq: "YNWManual.md" }) {
      childMarkdownRemark {
        htmlAst
      }
    }
    RNGManual: file(relativePath: { eq: "RNGManual.md" }) {
      childMarkdownRemark {
        htmlAst
      }
    }
    RLGManual: file(relativePath: { eq: "RLGManual.md" }) {
      childMarkdownRemark {
        htmlAst
      }
    }
    RIGManual: file(relativePath: { eq: "RIGManual.md" }) {
      childMarkdownRemark {
        htmlAst
      }
    }
    RCGManual: file(relativePath: { eq: "RCGManual.md" }) {
      childMarkdownRemark {
        htmlAst
      }
    }
    RDGManual: file(relativePath: { eq: "RDGManual.md" }) {
      childMarkdownRemark {
        htmlAst
      }
    }
    ICPManual: file(relativePath: { eq: "ICPManual.md" }) {
      childMarkdownRemark {
        htmlAst
      }
    }
    RCWManual: file(relativePath: { eq: "RCWManual.md" }) {
      childMarkdownRemark {
        htmlAst
      }
    }
    NFLManual: file(relativePath: { eq: "NFLManual.md" }) {
      childMarkdownRemark {
        htmlAst
      }
    }
    NBAManual: file(relativePath: { eq: "NBAManual.md" }) {
      childMarkdownRemark {
        htmlAst
      }
    }
    MLBManual: file(relativePath: { eq: "MLBManual.md" }) {
      childMarkdownRemark {
        htmlAst
      }
    }
    RSGManual: file(relativePath: { eq: "RSGManual.md" }) {
      childMarkdownRemark {
        htmlAst
      }
    }
  }
`
